export const UPDATE_ADDRESS_FREEZING_STATUS = 'UPDATE_ADDRESS_FREEZING_STATUS';

function accountReducer (state = {}, action) {
  switch (action.type) {
    case UPDATE_ADDRESS_FREEZING_STATUS:
      let newState = {...state};
      newState[action.payload.address] = {
        address: action.payload.address,
        state: action.payload.state
      };

      return newState;
    default:
      return state;
  }
}

export default accountReducer;


// WEBPACK FOOTER //
// ./src/storage/FrozenAddressesReducer.js